import { FC } from 'react';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { noDataTranslations } from './translations';
import { NoDataTransFields } from './types';
import styles from './noData.module.scss';

export const NoDataComponent: FC = () => {
  const { t } = useMyTranslations<NoDataTransFields>([noDataTranslations.name]);

  return <div className={styles.content}>{t('text')}</div>;
};
